import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  // Only reset scroll on an actual page change. Keying this on the whole
  // `location` object also fires on hash-only changes (in-page anchor
  // links like #faq-cloud_services), which would immediately fight the
  // browser's native scroll-to-anchor behavior and require a second click.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
